import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AgentAssessment } from '../../models/agent-assessment';

export const getCountryAiAssessment: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<AgentAssessment[]> = (fetchContext, programId, countryId, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/ai-assessment`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AgentAssessment[]>(fetchContext.errorStore, response, 'get country AI assessment'));
